import OneSignal from 'react-onesignal';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from './lib/reducers/userSlice';

const useOneSignal = (appId: string) => {
  const user = useSelector(selectUser);

  useEffect(() => {
    const initializeOneSignal = async () => {
      if (!OneSignal) return;

      await OneSignal.init({
        appId: appId,
        serviceWorkerParam: { scope: '/push/onesignal/' },
        serviceWorkerPath: 'push/onesignal/OneSignalSDKWorker.js',
        allowLocalhostAsSecureOrigin: true,
        notifyButton: {
          enable: true,
        },
        promptOptions: {
          autoPrompt: true,
          force: true,
          slidedown: {
            enabled: true,
            autoPrompt: false,
            actionMessage:
              "We'd like to show you notifications about the status of your shipments.",
            acceptButtonText: 'Allow',
            cancelButtonText: 'No thanks',
          },
        },
      });
    };

    OneSignal.User.PushSubscription.addEventListener('change', async event => {
      if (event.current.token && user) {
        OneSignal.login(user.id);
      }
    });

    OneSignal.Notifications.addEventListener('foregroundWillDisplay', event => {
      console.log('🔔 received:', event);
      const { title, body, additionalData, icon } = event.notification;

      if (Notification.permission === 'granted') {
        new Notification(title || 'Frayt', {
          body,
          icon: icon,
          data: additionalData,
        });
      }
    });

    initializeOneSignal();
  }, [appId, user]);
};

export default useOneSignal;
